exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2.colorBlack , h1.colorBlack  {\r\n    color: #000;\r\n}\r\n\r\n@media only screen and (max-width: 30rem) {\r\n    .bbuheader.margin-bottom-xlarge {\r\n        margin-bottom: 1.5rem !important;\r\n    }\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/assets/css/title.css
// module id = 1776
// module chunks = 0